// core
import { ARTICLE_KEY } from './config';
import { Banners } from '_core/views/Banners';
import { slots as basicSlots, Slot, Props, StartPacks } from 'basic/slots';
import { ReferralLink } from '_core/components/ReferralLink';
import { BriefStats } from '_core/views/BriefStats';
import { Readings } from '_core/views/Readings';
//import { Income } from '_core/views/Income';
import { PopupMessages } from 'basic/views/PopupMessages';
import { Iframe } from '_core/components/Iframe';

export * from 'basic/slots';


export const slots = {
  ...basicSlots,

  dashboard: [
    Slot(ARTICLE_KEY.DASHBOARD_SLOT),
    Banners,
    //Income,
    BriefStats,
    PopupMessages,
    ReferralLink,
    Readings,
    StartPacks,
  ],

  about: [Slot(ARTICLE_KEY.ABOUT_SLOT)],
  
  subscribe: [
    Props(Iframe, { height: 'calibrate', src: '/templ/subscribetmpl.html' })
  ],
}
